var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"8","offset-lg":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('general_conditions.content'))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }